var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items.length)?_c('v-breadcrumbs',{staticClass:"pa-0 breadcrumbs",attrs:{"items":_vm.items,"divider":">"},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_c('v-breadcrumbs-item',{attrs:{"disabled":item.disabled,"to":item.to,"exact":""}},[_vm._v(" "+_vm._s(item.text)+" ")])]}}],null,false,3688075015)}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }